//** Component  */
import React from "react";
import BaseComponent from "../../shared/baseComponent";
import Table from "../../components/table/Table";

//*** Lib */
import { Navigate } from "react-router";
import { Bars } from "react-loader-spinner";
import appUserDetailServices from "../../services/domainServices/appUserDetailServices";
import FormFieldGroup from "../../components/UI Element/FormGrop/FormFieldGroup";

export default class AppUserList extends BaseComponent {
  constructor(props) {
    super(props);
    this.appUserListService = new appUserDetailServices();
    this.state = {
       pagination: this.appUserListService.pagination,
       searchList: this.appUserListService.dataItem,
      setIsLoad: false,
      dataList: [],
      TotalCount: [],
    };
    this.appUserListService.onUpdateState = this.updateState.bind(this);
  }

  //** Constructor  and Component method */
  componentDidMount() {
    const requestData = {
      clientID: process.env.REACT_APP_Test_CLIENTID,  
      secretKey: process.env.REACT_APP_Test_SECRETKEY,  
       ...this.state.pagination
    };
    this.appUserListService.onGetUsers(requestData);
  }

  handleChangeEvent = (name, value) => {
    let detail = this.state.pagination;
    detail[name] = value;
    this.setState({ searchList: { ...detail } });
  };

  handleChange = (name, value) => {
    let detail = this.state.pagination;
    detail[name] = value;
    if (name === "searchText") {
      detail[name] = value.trim();
      let data = { ...this.state.pagination };
      data.pageNo = 1;
      const requestData = {
        clientID: process.env.REACT_APP_Test_CLIENTID,  
        secretKey: process.env.REACT_APP_Test_SECRETKEY,  
        ...this.state.pagination
      };
      this.appUserListService.onGetUsers(requestData);
      this.setState({ pagination: { ...data } });
    }
    this.setState({ searchList: { ...detail } });
  };

  handleSearch = () => {
    const { searchText } = this.state.searchList;
    if (!searchText || searchText.trim() === "") {
      this.appUserListService.apiService.serviceManager.swalServices.WarningToaster("Please Enter an username to search."); 
      return;  
    }
    let detail = { ...this.state.pagination, ...this.state.searchList, pageNo: 1 };
    this.setState({ pagination: detail, setIsLoad: true });

    const requestData = {
      clientID: process.env.REACT_APP_Test_CLIENTID,  
      secretKey: process.env.REACT_APP_Test_SECRETKEY,  
      ...detail,
    };
    this.appUserListService.onGetUsers(requestData);
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />;
    }
    return (
    
      <div className="ManageoperationalList-search mt-1">
        <div className="top-search-add-button-sec mb-3">
          <div className="left-searchbar-sec app-user-list">
            {this.appUserListService.SearchformFields.map((Item, index) => {
              return (
                <>
                  <FormFieldGroup
                    className="app-user-list-label"
                    column={Item}
                    value={this.state.searchList[Item.fieldName]}
                    onChange={(event) =>
                      this.handleChangeEvent(Item.fieldName, event.target.value)
                    }
                    onKeyPress={(e) =>
                      e.key === "Enter" &&
                      this.handleChange(Item.fieldName, e.target.value)
                    }
                    key={index}                  
                  />
                  <div className="app-user-list-btn ">
                    <button 
                      className="btn-hover color-3 active " 
                      onClick={this.handleSearch}
                    >
                      Search
                    </button>
                  </div>
                </>
              );
            })}
          </div>
          
        </div>
        <div className="users-list">
          {this.state.setIsLoad ? (
            <Bars
              className="row"
              wrapperStyle={{ marginTop: "150px" }}
              color="#3c4b64"
              height={55}
              width="100%"
              visible={this.state.setIsLoad}
            />
          ) : (

            <Table
              columns={this.appUserListService.gridColmns}
              rows={this.state.dataList}
              sortingColumns={[]}
              pagination={this.state.pagination}
              totalCount={this.state.TotalCount}
              totalResultes={this.state.TotalCount}
              setPagination={this.appUserListService.onPageChange.bind(this)}
              customScope={[
                {
                  column: "isActive",
                  renderTableData:
                    this.appUserListService.gridCheckBoxCol.bind(this),
                },
              ]}
            />
          )}
        </div>
      </div>
    );
  }
}
